import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {useTranslation} from "react-i18next";
import SubMenuMobile from "./components/SubMenuMobile";
import {ListItem} from "@mui/material";
import SubMenuDesktop from "./components/SubMenuDesktop";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import logo_text from "../../../assets/img/logo_full.svg"
const drawerWidth = 240;

export default function DrawerAppBar(props) {
    const [t] = useTranslation('common');
    const navItems = [
        {
            title: t('menu.splendos'),
            link: 'splendos'
        },
        {
            title:t('menu.splendosGrid'),
            link: 'splendosGrid'
        },
        {
            title:t('menu.splendosMobile'),
            link: 'splendosMobile'
        },
        {
            title:t('menu.blog'),
            link: 'blog'
        },
        {
            title:t('menu.help'),
            link: 'help'
        }
    ];
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const createNavigationHandler = (navigationLink) => () => {
        handleClickScroll(navigationLink);
    }

    const handleClickScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            // 👇 Will scroll smoothly to the top of the next sections
            element.scrollIntoView({ behavior: "smooth"});
        }
    };

    const drawer = (
        <Box sx={{ textAlign: 'center', color: "white", backgroundColor: "black", height: "100%" }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                <img src={logo_text} alt="logo_text" />
            </Typography>
            <Divider />
            <List>
                {navItems.map((item, key) => {
                    return item.subMenu ?
                        <SubMenuMobile key={key} {...item} /> :
                        <ListItem key={key}>
                            <ListItemButton
                                onClick={()=>{
                                    createNavigationHandler(item.link)();
                                    handleDrawerToggle();
                                }}
                            >
                                <ListItemText primary={item.title} />
                            </ListItemButton>
                        </ListItem>
                })}
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar style={{ background: '#000', paddingTop: 10 }} component="nav">
                <Toolbar style={{  }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ display: { xs: 'none', sm: 'block' } }}
                    >
                        <img src={logo_text} alt="logo_text" />
                    </Typography>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Box style={{margin: "0 200px", display: "flex", flexDirection:"row"}}>
                            {navItems.map((item,key) => {
                                return item.subMenu ?
                                    <SubMenuDesktop key={key} {...item} /> :
                                    <Button onClick={createNavigationHandler(item.link)} key={key} sx={{ color: '#fff', margin: "0 10px" }}>
                                        {item.title}
                                    </Button>
                            })}
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box component="nav">
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
        </Box>
    );
}
